import * as React from "react"

function IconDelete() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="21" fill="none" viewBox="0 0 19 21">
      <path
        stroke="#F9B233"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M16.575 7.718s-.543 6.735-.858 9.572c-.15 1.355-.987 2.149-2.358 2.174-2.61.047-5.221.05-7.83-.005-1.318-.027-2.141-.831-2.288-2.162-.317-2.863-.857-9.58-.857-9.58M17.958 4.489H1M14.69 4.489a1.648 1.648 0 01-1.615-1.324l-.243-1.216A1.28 1.28 0 0011.595 1H7.362a1.28 1.28 0 00-1.237.949l-.243 1.216a1.648 1.648 0 01-1.615 1.324"
      ></path>
    </svg>
  )
}

export default IconDelete
